"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CommandAddDistributionPlan model module.
 * @module model/CommandAddDistributionPlan
 * @version 1.1.3-alpha.1
 */
class CommandAddDistributionPlan {
  /**
   * Constructs a new <code>CommandAddDistributionPlan</code>.
   * @alias module:model/CommandAddDistributionPlan
   * @param name {String} 
   */
  constructor(name) {
    CommandAddDistributionPlan.initialize(this, name);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, name) {
    obj['name'] = name;
  }

  /**
   * Constructs a <code>CommandAddDistributionPlan</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CommandAddDistributionPlan} obj Optional instance to populate.
   * @return {module:model/CommandAddDistributionPlan} The populated <code>CommandAddDistributionPlan</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CommandAddDistributionPlan();
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('is_active')) {
        obj['is_active'] = _ApiClient.default.convertToType(data['is_active'], 'Boolean');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('media_list')) {
        obj['media_list'] = _ApiClient.default.convertToType(data['media_list'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CommandAddDistributionPlan</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommandAddDistributionPlan</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CommandAddDistributionPlan.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
      throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
    }
    // ensure the json data is a string
    if (data['media_list'] && !(typeof data['media_list'] === 'string' || data['media_list'] instanceof String)) {
      throw new Error("Expected the field `media_list` to be a primitive type in the JSON string but got " + data['media_list']);
    }
    return true;
  }
}
CommandAddDistributionPlan.RequiredProperties = ["name"];

/**
 * @member {String} name
 */
CommandAddDistributionPlan.prototype['name'] = undefined;

/**
 * @member {Boolean} is_active
 */
CommandAddDistributionPlan.prototype['is_active'] = undefined;

/**
 * @member {String} description
 */
CommandAddDistributionPlan.prototype['description'] = undefined;

/**
 * @member {String} media_list
 */
CommandAddDistributionPlan.prototype['media_list'] = undefined;
var _default = exports.default = CommandAddDistributionPlan;